import { MENU_MODEL, LAYOUT_SET_OPENWORLD, CHECK_POINT_ACHIEVE, CHECK_POINT_DISTANCE_METER, MISSION_COMPLETE, ACHIEVE_POINT, LAST_CHECK_POINT, NEW_MISSION, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    achievePoint: false,
    totalCheckPoint: 0,
    currentCheckPoint: "",
    checkPointDistance: 0,
    isMisssionComplete: false,
    lastCheckPoint: false,
    newMission: false,
    isOpenMenu: false,
    layoutOpenWorld: 'layout_center'
}

export const checkPointReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_POINT_ACHIEVE:
            return {
                ...state,
                totalCheckPoint: action.payload.totalCheckPoint,
                currentCheckPoint: action.payload.currentCheckPoint
            }
        case CHECK_POINT_DISTANCE_METER:
            return {
                ...state,
                checkPointDistance: action.payload
            }
        case MISSION_COMPLETE:
            return {
                ...state,
                isMisssionComplete: action.payload
            }
        case ACHIEVE_POINT:
            return {
                ...state,
                achievePoint: action.payload
            }
        case LAST_CHECK_POINT:
            return {
                ...state,
                lastCheckPoint: action.payload
            }
        case NEW_MISSION:
            return {
                ...state,
                newMission: action.payload
            }
        case MENU_MODEL:
            return {
                ...state,
                isOpenMenu: action.payload
            }
        case LAYOUT_SET_OPENWORLD:
            return {
                ...state,
                layoutOpenWorld: action.payload
            }
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}